export default __webpack_public_path__ + "static/media/team89.589a689f.JPG";